// eslint-disable-next-line import/named
import { iInitiateData, iAuthorisedFineDescriptions, iBasicInfoResponse, iPaymentArrangementResponse, iEligibleNominationResponse, iValidFileInfo, iNominationGroundsInfo, iSponsor } from '@interfaces/interfaces';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

const mPOST = 'POST';
const header = {
  'Content-Type': 'application/json',
};

const getInitiate = async (obligationNum: string, formType: string): Promise<iInitiateData> => {
  const url = `${API_URL}sitecore/${formType}/Initiate`;
  const payload = {
    obligationNumber: obligationNum
  };
  try {
    const response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    if (response.status !== 200) {
      throw new Error(response.toString());
    }
    const results = await response.json();
    return results;
  } catch (ex) {
    throw new Error('Error in response');
  }
};

const getObligationOptions = async (obligationNum: string, formType: string): Promise<iAuthorisedFineDescriptions> => {
  const url = `${API_URL}sitecore/${formType}/GetObligationOptions`;
  const payload = {
    obligationNumber: obligationNum
  };
  let response: Response;
  try {
    response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iAuthorisedFineDescriptions>{};
  } catch (ex) {
    throw new Error('Something wrong in response of Obligation Options!');
  }
};

const getBasicInfo = async (obligationNum: string, formType: string): Promise<iBasicInfoResponse> => {
  const url = `${API_URL}sitecore/${formType}/GetBasicInfo`;
  const payload = {
    obligationNumber: obligationNum
  };
  let response: Response;
  try {
    response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iBasicInfoResponse>{};
  } catch (ex) {
    throw new Error('Error in Response');
  }
};

const getPaymentArrangement = async (obligationNum: string[], formType: string): Promise<iPaymentArrangementResponse> => {
  const url = `${API_URL}sitecore/${formType}/GetPaymentArrangement`;
  const payload = {
    finesList: obligationNum
  };
  let response: Response;
  try {
    response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iPaymentArrangementResponse>{};
  } catch (ex) {
    throw new Error('Error in GetPaymentArrangement Response');
  }
};

const getEligibleNominationList = async (obligationNum: string[], formType: string): Promise<iEligibleNominationResponse> => {
  const url = `${API_URL}sitecore/${formType}/GetEligibleNominationList`;
  const payload = {
    finesList: obligationNum
  };
  let response: Response;
  try {
    response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iEligibleNominationResponse>{};
  } catch (ex) {
    throw new Error('Error in GetEligibleNomination Response');
  }
};

const uploadFileAWS = async (file: File, obligationNum: string, formType: string): Promise<string> => {
  const url = `${API_URL}sitecore/File/Upload`;
  if (file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('obligationNumber', obligationNum);
    formData.append('formType', formType);
    const response = await fetch(url, {
      method: mPOST,
      body: formData,
    });
    const results = await response.json();
    return results;
  }
  return '';
};

const getValidFilesConfig = async (): Promise<iValidFileInfo[]> => {
  const url = `${API_URL}sitecore/File/GetValidFilesConfig`;
  let response: Response;
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: header,
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iValidFileInfo[]>{};
  } catch (ex) {
    throw new Error('Error in Response');
  }
};

const getGroundsInfo = async (obligationNum: string, formType: string): Promise<iNominationGroundsInfo> => {
  const url = `${API_URL}sitecore/${formType}/GetGroundsInfo`;
  const payload = {
    obligationNumber: obligationNum
  };
  let response: Response;
  try {
    response = await fetch(url, {
      method: mPOST,
      headers: header,
      body: JSON.stringify(payload),
    });
    const responseBody = await response.json();
    if (response.status === 200) {
      return responseBody;
    }
    return <iNominationGroundsInfo>{};
  } catch (ex) {
    throw new Error('Something wrong in response of Grounds Information!');
  }
};
const validateAbnAsync = async (value: string): Promise<string> => {
  const url = `${API_URL}sitecore/PartialForms/ABNLookUp`;
  const payload = {
    InputNumber: value,
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.text())
    .then((responseBody) => {
      if (responseBody === 'False') {
        return 'Please enter a valid ABN';
      }
      return '';
    })
    .catch((error) => error);
};

const validateAcnAsync = async (value: string): Promise<string> => {
  const url = `${API_URL}sitecore/PartialForms/ACNLookUp`;
  const payload = {
    InputNumber: value,
  };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.text())
    .then((responseBody) => {
      if (responseBody === 'False') {
        return 'Please enter a valid ACN';
      }
      return '';
    })
    .catch((error) => error);
};

const getWDPData = async (): Promise<iSponsor[]> => {
    const url = `${API_URL}sitecore/Sponsor/GetSponsorList`;
    let response: Response;
    try {
      response = await fetch(url, {
        method: mPOST,
      headers: header,
      });
      const responseBody = await response.json();
      if (response.status === 200) {
        return responseBody;
      }
      return <iSponsor[]>{};
    } catch (ex) {
      throw new Error('Error in Response');
    }
  };

  const validateEmailAsync = async (email: string, obligationNum: string, formType: string): Promise<string> => {
    const url = `${API_URL}sitecore/PartialForms/ValidateEmail`;
    const payload = {
      Email: email,
      obligationNumber: obligationNum,
      formName: formType
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseBody) => {
        if (responseBody?.StatusCode === 200) {
          return responseBody.Message || '';
        }
        return '';
      })
      .catch((error) => error);
  };

  const validateMobileAsync = async (mobile: string, obligationNum: string, formType: string): Promise<string> => {
    const url = `${API_URL}sitecore/PartialForms/ValidateMobile`;
    const payload = {
      Mobile: mobile,
      obligationNumber: obligationNum,
      formName: formType
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseBody) => {
        if (responseBody?.StatusCode === 200) {
          return responseBody.Message || '';
        }
        return '';
      })
      .catch((error) => error);
  };

export { getInitiate, getObligationOptions, getBasicInfo, uploadFileAWS, getPaymentArrangement, getEligibleNominationList, getValidFilesConfig, getGroundsInfo, validateAbnAsync, validateAcnAsync, getWDPData, validateEmailAsync, validateMobileAsync };
